<template>
  <div>
    <div class="flex justify-between">
      <!-- <h2 class="text-2xl font-semibold">Order Management</h2> -->
    </div>
    <MIS />
  </div>
</template>

<script>
import MIS from "./components/MISadmin.vue";
export default {
  components: {
    MIS,
  },
};
</script>

<style></style>
